import React from "react";
import Navbar from "../Navbar/Navbar";
import { useState, useEffect } from "react";
import { API } from "../../Redux/actions/API";
// import { ToastContainer, toast } from 'react-toastify';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Message() {
  const [message, setMessage] = useState("");
  const [rank, setRank] = useState("");

  const Massage_API = async () => {
    if (rank && message) {
      try {
        let res = await API.post(`/SaveMessageByAdmin`, {
          imagerank: rank,
          message: message,
        });

        console.log("res", res);
        if (res.data.data === "SUCCESSFUL") {
          toast.success(res.data.data);
          window.location.reload();
        } else {
          toast.error(res.data.data);
        }
      } catch (e) {
        console.log("Somthing Error in Massage API", e);
      }
    } else {
      toast.error("Please Fill All The Fields");
    }
  };

  const handleInputChange = (event) => {
    const newValue = event.target.value.replace(/[^a-z0-9 ]/gi, "");
    setRank(newValue);
  };

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Dashboard Messages</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <h1 className="fw-bold">
                                  Dashboard Message Table
                                </h1>
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                {/* <!---onclick number increase start--> */}
                                <div className="form-group">
                                  <label>Subject</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Subject"
                                    maxLength="50"
                                    value={rank}
                                    onChange={handleInputChange}
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Message</label>
                                  <textarea
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Message"
                                    onChange={(e) => setMessage(e.target.value)}
                                    maxLength="500"
                                  />
                                </div>

                                <div class="joinbtn d-flex flex-row-reverse me-auto ">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => Massage_API()}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div class="col-md-6">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <h1 className="fw-bold">Image Table</h1>
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <!---onclick number increase start-->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
}

export default Message;
